__turbopack_context__.v({
  "container": "LightboxButton-module__-pi_uW__container",
  "fadeInItems": "LightboxButton-module__-pi_uW__fadeInItems",
  "spacing--lg": "LightboxButton-module__-pi_uW__spacing--lg",
  "spacing--md": "LightboxButton-module__-pi_uW__spacing--md",
  "spacing--sm": "LightboxButton-module__-pi_uW__spacing--sm",
  "spacing--xl": "LightboxButton-module__-pi_uW__spacing--xl",
  "spacing--xs": "LightboxButton-module__-pi_uW__spacing--xs",
  "spacing--xxl": "LightboxButton-module__-pi_uW__spacing--xxl",
  "spacing--xxs": "LightboxButton-module__-pi_uW__spacing--xxs",
  "spacing--xxxl": "LightboxButton-module__-pi_uW__spacing--xxxl",
  "spacing--xxxs": "LightboxButton-module__-pi_uW__spacing--xxxs",
});
